import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

/**
 * AIO-82875: what the push snackbar shows. The caller passes final text (translated copy, or the push's own
 * title and body). `title` renders as text; `body` renders as HTML, so it must be escaped
 * (FirebaseMessagingService.foregroundNotice()) or our own translated copy.
 */
export interface PushNotificationCTAData {
  title: string;
  body: string;
  buttonConfirm?: string;
  buttonCancel?: string;
  /** Runs synchronously inside the Confirm tap: iOS shows the push permission prompt only for a request made during a tap. */
  onConfirm?: () => void;
}

/**
 * AIO-82875: the push snackbar. Two uses:
 * - the iOS installed-app CTA that asks for push permission from a tap (Confirm / Later);
 * - the in-app notice for a push that arrives while the app is open (the browser shows nothing then).
 */
@Component({
  selector: 'app-push-notification-cta',
  imports: [TranslateModule],
  templateUrl: './push-notification-cta.component.html',
  styleUrl: './push-notification-cta.component.scss'
})
export class PushNotificationCTAComponent {

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: PushNotificationCTAData,
    private snackBarRef: MatSnackBarRef<PushNotificationCTAComponent>,
  ) { }

  onConfirm(): void {
    /* First, before anything else in the tap - see PushNotificationCTAData.onConfirm */
    if (typeof this.data.onConfirm === 'function') {
      this.data.onConfirm();
    }

    this.onClose();
  }

  onClose(): void {
    this.snackBarRef.dismiss();
  }
}
